<template>
     <div class="col margin-bottom-50 consumer">
        <div class="form">
            <div class="row">
                <div class="form_content clearfix w-100">
                    <span class="required-fields more-top">(*) {{ $t('default.Requiredfields')}}</span>

                    <template v-if="optionsThemes.length > 1">
                        <div class="title">
                            <h3>&nbsp;</h3>
                        </div>

                        <section class="col-sm-12 q">
                            <form-radio-themes v-model="contact.theme_id" :error="errors.theme_id" name="theme_id" :label="$t('default.Choose')" :options="optionsThemes" :required="true"></form-radio-themes>

                            <div class="clear"></div>
                        </section>

                        <div class="clear"></div>
                    </template>

                    <div class="title">
                        <h3>{{ $t('default.ContactData') }}</h3>
                    </div>

                    <section class="col-sm-12 q">
                        <section class="vraag w100 clearfix">
							<p class="toelichting">{{ $t('default.AskForContactInformation') }}</p>
						</section>

                        <form-radio v-model="contact.gender" :error="errors.gender" name="gender" :label="$t('default.HeaderStart')" :options="optionsGender" :required="true"></form-radio>
                        <form-input v-model="contact.first_name" :error="errors.first_name" name="first_name" :label="$t('default.Firstname')" :required="true"></form-input>
                        <form-input v-model="contact.last_name" :error="errors.last_name" name="last_name" :label="$t('default.Lastname')" :required="true"></form-input>
                        <form-input v-model="contact.street" :error="errors.street" name="street" :label="$t('default.Address')" v-if="block.expanded" :required="true"></form-input>
                        <form-input v-model="contact.zip_code" :error="errors.zip_code" name="zip_code" :label="$t('default.Zipcode')" v-if="block.expanded" :required="true"></form-input>
                        <form-input v-model="contact.city" :error="errors.city" name="city" :label="$t('default.City')" v-if="block.expanded" :required="true"></form-input>
                        <form-datepicker v-model="contact.year_of_birth" :error="errors.year_of_birth"  name="year_of_birth" :label="$t('default.Yearofbirth')" :options="options" v-if="block.show_year_of_birth" :required="true"></form-datepicker>
                        <form-input v-model="contact.email" :error="errors.email" name="email" :label="$t('default.Email')" :required="true"></form-input>
                        <form-input v-model="contact.phone" :error="errors.phone" name="phone" :label="$t('default.Phone')" :required="true"></form-input>
                        <form-textarea v-model="contact.description_consumer" :error="errors.description_consumer" name="description_consumer" :label="$t('default.Question')" :required="true"></form-textarea>
                        <form-recaptcha ref="recaptcha" :error="errors.recaptcha"></form-recaptcha>
                    </section>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 next_prev">
                    <section class="col-md-2 col-sm-3 col-xs-4 buttons right">
                        <div class="row">
                            <button type="submit" class="button full" @click="submit" :disabled="disabled">{{ $t('default.Sendbutton') }}</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormInput from "@/components/form-elements/FormInput.vue"
import FormRadio from "@/components/form-elements/FormRadio.vue"
import FormRadioThemes from "@/components/form-elements/FormRadioThemes.vue"
import FormTextarea from "@/components/form-elements/FormTextarea.vue"
import FormRecaptcha from "@/components/form-elements/FormRecaptcha.vue"
import FormDatepicker from "@/components/form-elements/FormDatepicker.vue";
import Block from "@/mixins/Block.js"
import Gender from "@/mixins/Gender.js"
import SetErrors from "@/mixins/SetErrors.js"
import Options from "@/mixins/OptionsDatepicker.js"
import i18n from "../i18n"
import router from "@/router"
import { axios } from "@/helpers"

export default {
    components: {
        FormInput,
        FormRadio,
        FormRadioThemes,
        FormTextarea,
        FormRecaptcha,
        FormDatepicker,
    },
    mixins: [Block, Gender, SetErrors, Options],
    data() {
        return {
            disabled: false,
            contact: {
                theme_id: null,
                gender: null,
                first_name: null,
                last_name: null,
                year_of_birth: null,
                email: null,
                phone: null,
                street: null,
                zip_code: null,
                city: null,
                description_consumer: null,
            },
            errors: {
                theme_id: null,
                gender: null,
                first_name: null,
                last_name: null,
                year_of_birth: null,
                email: null,
                phone: null,
                street: null,
                zip_code: null,
                city: null,
                description_consumer: null,
                recaptcha: null
            }
        }
    },
    computed: {
        optionsThemes() {
            let themes = [];
            this.block.themes.forEach(theme => {
                themes.push({
                    'value': theme.id,
                    'label': theme.name
                });
            });

            return themes;
        }
    },
    methods: {
            submit() {
                this.disabled = true;

                this.resetErrors();

                let params = JSON.parse(JSON.stringify(this.contact));//deep clone
                params.block_id = this.block.id;
                params.recaptcha = document.getElementsByClassName('g-recaptcha-response')[0].value;

                axios
                    .post('/' + i18n.locale.split("_")[0] + '/contact', params)
                        .then(response => {
                            this.disabled = false;

                            if(typeof response?.data?.success !== "undefined") {
                                this.$router.push({ name: 'app-consumer-thanks', params: { 'slug': router.currentRoute.params.slug, 'id' : this.block.id, 'contact': this.contact } });
                            }

                        }).catch(error  => {
                            this.disabled = false;

                            if(typeof error?.response?.data?.errors !== "undefined") {
                                this.setErrors(error.response.data.errors);
                            }

                        });
            }
        }
}
</script>